import { Breadcrumb } from "../../../../../core/Breadcrumb.js";
import { Text } from "../../../../../core/Text.js";
import { useChromeHints } from "../../../../shared/chromeHints.js";
import type { BattleCreateHeadingContent } from "../../../battlesContent.js";

/** Where the page sits, its one h1 and how a battle is built; the phone bar gets Back. */
export function BattleCreateHeading({
  trail,
  current,
  title,
  description,
  back,
}: BattleCreateHeadingContent) {
  useChromeHints({ back });
  return (
    <div className="flex flex-col gap-3">
      <Breadcrumb
        items={[...trail.map(({ href, label }) => ({ href, label })), { label: current }]}
        className="max-md:hidden"
      />
      <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
        {title}
      </Text>
      <Text as="p" variant="body-b1" tone="secondary" className="max-w-2xl">
        {description}
      </Text>
    </div>
  );
}
